import {all, put, call, fork, takeLatest} from "redux-saga/effects";
import {LocatorMapActionType, LocationSearchByLocationIdAction} from "../../actions/postshop-locator/locatorMapActions";
import {postshopLocatorService} from "../../../services/postshopLocatorService";
import {PostshopLocation} from "../../../models/PostshopLocation";
import {locatorResultsActions} from "../../actions/postshop-locator/locatorResultsActions";
import {push} from "connected-react-router";
import {paths} from "../../../routes/routes";
import {locatorSuggestionActions} from "../../actions/postshop-locator/locatorSuggestionActions";
import {postshopLocatorUIActions} from "../../actions/postshop-locator/postshopLocatorUIActions";
import {locationsActions} from "../../locations/actions";

//this happens when a user enters url of type /location/:locationId-:locationName i.e: /location/72629-mobil-waharoa
function* findLocationOnMap(action : LocationSearchByLocationIdAction) {
    try {
        const location: PostshopLocation = yield call(postshopLocatorService.getLocationById, action.payload.locationId);
        // Removed location address since the load would work without it
        // const locationAddress = location && location.address ? location.address.replace(/[()!#$%^@]/g, '') : null;
        // Clear location suggestions
        yield put(locatorSuggestionActions.clearSuggestionsRequested());
        const exactLocations = [location];
        // Change PostshopLocator UI state to EXACT_LOCATION
        yield put(postshopLocatorUIActions.setUIStateExactLocation());
        yield put(locatorResultsActions.setResultsAction(exactLocations));
        // Replace all locations
        yield put(locationsActions.replaceLocations({locations: exactLocations}));
        // Set field
        yield put(locatorSuggestionActions.setSearchFieldValueAction(location.name));
    } catch (e) {
        yield put(push(paths.SERVER_ERROR));
    }
    // Set loading to finished
    yield put(locatorResultsActions.resultsLoadedAction());

}

function* watchLocationSearchByIDRequest() {
    yield takeLatest(LocatorMapActionType.LOCATION_SEARCH_BY_LOCATION_ID, findLocationOnMap);
}

export default function* locatorMapSaga() {
    yield all([
        fork(watchLocationSearchByIDRequest),
        fork(watchLocationSearchByIDRequest),
    ])
}


// WEBPACK FOOTER //
// ./src/redux/sagas/postshop-locator/locatorMapSaga.tsx